import { render, staticRenderFns } from "./WorkShiftDelete.vue?vue&type=template&id=cf472ad2&scoped=true&"
import script from "./WorkShiftDelete.vue?vue&type=script&lang=js&"
export * from "./WorkShiftDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf472ad2",
  null
  
)

export default component.exports